import React, { useState } from 'react'
import { Alert, Button, Collapse } from 'react-bootstrap';
import styles from './ProfileStatus.module.css'
import axios from '../../utils/axios';
import { DRAFT, PUBLISHED, UNPUBLISHED, TEAR_SHEET, STATUS_LABELS } from '../../constants';
import { useIntl } from 'react-intl';

/** Displays status message on a space profile */
export default ({ spaceProfile, individualProfile, generalSettings = {} }) => {
  const { status_history, guid, privateKey, assetImagesZip } = spaceProfile
  const {ada_pdf: adaPdf, profile_pdf: profilePdf, preview_enabled } = individualProfile
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  if (!status_history || !status_history.length) return null;
  const [showLink, setShowLink] = useState(false);
  const [hideZipMessage, setHideZipMessage] = useState(false);

  const { user, status, timestamp } = status_history[status_history.length - 1];

  const date = intl.formatDate(new Date(timestamp));
  const time = intl.formatTime(new Date(timestamp));

  const historyMessage = intl.formatMessage({ id: 'ProfileStatus.historyMessage' }, { altered: <span className={styles.status}>{STATUS_LABELS[status]}</span>, user, date, time });
  const url = `${window.location.origin.toString()}/profile/${guid}`;
  const privateUrl = `${window.location.origin.toString()}/profile/${guid.split('').reverse().join('')}/${privateKey}`;

  const StatusAlert = ({ children, variant }) =>
    <Alert variant={variant}>{t('ProfileStatus.status')}: {historyMessage}
      {children ? <><br />{children}</> : null}
      {preview_enabled ? <><br />{t('ProfileStatus.preview')}: <a href={url} rel="noopener noreferrer" target="_blank">{url}</a></> : null}
    </Alert>

  const publishZippedImage = async () => {
    try {
      const updatedSpaceProfile = await axios.post(`/space-profiles/generate-zip`, { spaceProfile: { ...spaceProfile}})
      spaceProfile.generating_zip = updatedSpaceProfile.data.record.generating_zip
      setHideZipMessage(true);
    } catch (error) {
      console.log(error)
    }
  }

  const showGenerateZipButton = () => {
    return !spaceProfile.generating_zip && !assetImagesZip
  }

  const showZipGeneratingMessage = () => {
    return (hideZipMessage || spaceProfile.generating_zip) && !assetImagesZip
  }

  let zippedAssetImages = generalSettings ?
    <>
      {assetImagesZip ?
        <>
          {t('ProfileStatus.zippedAssetImages')}: <a href={assetImagesZip} rel="noopener noreferrer" target="_blank">{t('ui.download')}</a><br />
        </>
        : null }
      { showGenerateZipButton() ?
        <Button variant="none" className={`${styles.generateZipButton} btn-prime btn-sm` } onClick={() => publishZippedImage()}>
          {t('ProfileStatus.generateZippedAssetImages')}
        </Button>
        : null }
      { showZipGeneratingMessage() ?
        <p className={styles.zipFileMessage}>{t('ProfileStatus.generateZippImageMessage')}</p>
        : null }
    </> : null


  return (
    <div className={styles.profileStatusContainer}>
      {status === PUBLISHED ? (
        <StatusAlert variant="success">
          {t('ProfileStatus.availablAt')}: <a href={url} className="data-profile-link" rel="noopener noreferrer" target="_blank">{url}</a><br />
          {profilePdf ? <><a href={profilePdf} rel="noopener noreferrer" target="_blank">{t('ProfileStatus.viewProfilePdf')}</a><br /></> : null}
          {adaPdf ? <><a href={adaPdf} rel="noopener noreferrer" target="_blank">{t('ProfileStatus.viewAdaPdf')}</a><br /></> : null}
          {zippedAssetImages}
          <span onClick={() => setShowLink(!showLink)}>{t('ProfileStatus.privateLink')}: <Button size="sm" variant="link" className={`pl-0 ${styles.privateLink}`} style={{ fontSize: '12px' }}>{t('ProfileStatus.view')}</Button></span>
          <Collapse in={showLink}>
            <div className={`${styles.privateUrl} pt-2`}><a href={privateUrl} rel="noopener noreferrer" target="_blank">{privateUrl}</a></div>
          </Collapse>
        </StatusAlert>
      ) : null}
      {status === DRAFT ? <StatusAlert variant="warning">{zippedAssetImages}</StatusAlert> : null}
      {status === UNPUBLISHED ? <StatusAlert variant="danger">{zippedAssetImages}</StatusAlert> : null}
      {status === TEAR_SHEET ? <StatusAlert variant="danger">{zippedAssetImages}</StatusAlert> : null}
    </div>
  )
}
